import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-188fdfca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product__header" }
const _hoisted_2 = { class: "product__header--title" }
const _hoisted_3 = { class: "product__header--info" }
const _hoisted_4 = { class: "header__info--stars" }
const _hoisted_5 = { class: "header__info--rating" }
const _hoisted_6 = { class: "header__info--feedback" }
const _hoisted_7 = { class: "header__info--buy-count" }

import { IProduct } from '@/services';
import { toRefs, reactive } from 'vue';
import { allStars } from './constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductHeader',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: IProduct;
};



const { product } = reactive(props);
const { title, rating } = toRefs(product);

const getStars = () => {
  return Math.floor(rating.value);
};

const getRandom = (max: number): number => {
  return Math.floor(Math.random() * max) + 1;
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(title)), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allStars), (star) => {
          return (_openBlock(), _createBlock(_component_font_awesome_icon, {
            class: _normalizeClass({ gold: getStars() >= star }),
            key: star,
            icon: "fa-solid fa-star"
          }, null, 8 /* PROPS */, ["class"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(rating)), 1 /* TEXT */),
      _createElementVNode("span", _hoisted_6, _toDisplayString(getRandom(150)) + " feedbacks ", 1 /* TEXT */),
      _createElementVNode("span", _hoisted_7, " Bought more than " + _toDisplayString(getRandom(5) * 50) + " times ", 1 /* TEXT */)
    ])
  ]))
}
}

})